import { css, styled } from '@mui/material';

export const SContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
}));

export const STitleContainer = styled('div')(
  () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
);
